/**
 * When an Admin must give a reason for editing a shift.
 *
 * Mirrors the API rule in oppo_api/utils/editReason.js: the reason goes into
 * the shift history so an auditor can see why a time record was changed, so
 * it is required once the shift has a clock-in or has been closed out
 * (clocked out, approved, missed). Moving a future scheduled shift needs no
 * reason. Canceling has its own required reason and is handled separately.
 *
 * Pages hand the edit modals differently shaped objects (a raw API row, a
 * calendar/list mapping with `status` like "clocked-out", or a wrapper with
 * `originalData`), so this reads all of them.
 */

const WORKED_STATUSES = new Set(['clocked in', 'clocked out', 'approved', 'missed']);

function normalizeStatus(value) {
  if (!value) return '';
  return String(value).toLowerCase().replace(/[-_]+/g, ' ').trim();
}

export function shiftRequiresEditReason(shift) {
  if (!shift) return false;
  const original = shift.originalData || {};
  if (shift.clock_in || original.clock_in) return true;
  const candidates = [shift.shift_status, original.shift_status, shift.status];
  return candidates.some((s) => WORKED_STATUSES.has(normalizeStatus(s)));
}
